<template>
  <pages-editions-slug-participants-modal-component
    :biennial-entry-id="biennialEntryId"
  />
</template>

<script lang="ts" setup>
const props = defineProps({
  biennialEntryId: {
    type: Number,
    required: false
  }
})
</script>
